import { CreatePhotoResp } from 'types/api/response/create-photo-resp'

import { api } from './api'

export const createPhoto = (photo: FormData) => api.post<CreatePhotoResp>('/photos', photo)
